<template>
  <div>
    <h6>Formulär</h6>
    <form novalidate>
      <div class="mb-3">
        <label class="form-label" for="input-52">Give your survey a name</label>
        <input
          id="input-52"
          v-model="test"
          type="text"
          class="form-control"
          placeholder="Survey name"
          required
        >
      </div>
      <div class="mb-3">
        <label class="form-label">Select option</label>
        <div class="form-check">
          <input id="survey-type-1" v-model="surveyType" class="form-check-input" type="radio" name="survey-type" value="1">
          <label class="form-check-label" for="survey-type-1">GDQ</label>
        </div>
        <div class="form-check">
          <input id="survey-type-2" v-model="surveyType" class="form-check-input" type="radio" name="survey-type" value="2">
          <label class="form-check-label" for="survey-type-2">GDQ Short</label>
        </div>
        <div class="form-check">
          <input id="survey-type-3" v-model="surveyType" class="form-check-input" type="radio" name="survey-type" value="3">
          <label class="form-check-label" for="survey-type-3">OSC</label>
        </div>
        <div class="text-md">Please select the type of survey to create</div>
      </div>
    </form>

    <h6>Inmatningsfält</h6>
    <form novalidate>
      <div class="mb-3">
        <label class="form-label" for="input-1">A required input field</label>
        <input
          id="input-1"
          v-model="test"
          type="text"
          class="form-control"
          placeholder="Placeholder here"
          required
        >
      </div>

      <div class="mb-3">
        <label class="form-label" for="input-2">A valid input field</label>
        <input
          id="input-2"
          v-model="test2"
          type="text"
          class="form-control is-valid"
        >
      </div>

      <div class="mb-3">
        <label class="form-label" for="input-3">An invalid input field</label>
        <input
          id="input-3"
          v-model="name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': !state && name.length > 0, 'is-valid': state }"
          placeholder="Your name"
        >
        <div v-if="!state && name.length > 0" class="invalid-feedback">
          {{ invalidFeedback }}
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label" for="input-4">Survey input field</label>
        <input
          id="input-4"
          v-model="test3"
          type="text"
          class="form-control"
          placeholder="Test Survey"
        >
      </div>

      <h6>Dropdown</h6>
      <div class="mb-3">
        <select v-model="selectedOption" class="form-select mb-3">
          <option value="a">Option A</option>
          <option value="b" disabled>Option B (disabled)</option>
          <option :value="{ C: '3PO' }">Option with object value</option>
          <option :value="{ R: '2D2' }">Another option with object value</option>
        </select>
      </div>

      <h6>Radio</h6>
      <div class="mb-3">
        <label class="form-label">Select option</label>
        <div class="form-check">
          <input id="some-radio-a" v-model="selectedRadio" class="form-check-input" type="radio" name="some-radios" value="A">
          <label class="form-check-label" for="some-radio-a">Option A</label>
        </div>
        <div class="form-check">
          <input id="some-radio-b" v-model="selectedRadio" class="form-check-input" type="radio" name="some-radios" value="B">
          <label class="form-check-label" for="some-radio-b">Option B</label>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Select another option</label>
        <div class="form-check">
          <input id="some-radio-c" v-model="selectedRadio2" class="form-check-input" type="radio" name="some-radios2" value="C">
          <label class="form-check-label" for="some-radio-c">Option C</label>
        </div>
        <div class="form-check">
          <input id="some-radio-d" v-model="selectedRadio2" class="form-check-input" type="radio" name="some-radios2" value="D">
          <label class="form-check-label" for="some-radio-d">Option D</label>
        </div>
      </div>

      <h6>Checkbox</h6>
      <div class="mb-3">
        <label class="form-label">Choose a fruit</label>
        <div class="form-check" v-for="opt in checkOptions" :key="opt.value">
          <input
            :id="`fruit-${opt.value}`"
            v-model="selectedCheckbox"
            class="form-check-input"
            type="checkbox"
            name="flavour-2a"
            :value="opt.value"
          >
          <label class="form-check-label" :for="`fruit-${opt.value}`">{{ opt.text }}</label>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Choose a vegetable</label>
        <div class="form-check" v-for="opt in checkOptions2" :key="opt.value">
          <input
            :id="`veg-${opt.value}`"
            v-model="selectedCheckbox2"
            class="form-check-input"
            type="checkbox"
            name="flavour-2b"
            :value="opt.value"
          >
          <label class="form-check-label" :for="`veg-${opt.value}`">{{ opt.text }}</label>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'FormDemo',
  computed: {
    state () {
      return this.name.length >= 4
    },
    invalidFeedback () {
      if (this.name.length < 4) {
        return 'Name must be at least 4 letters'
      }
      return ''
    }
  },
  data () {
    return {
      test: '',
      test2: 'This field is validated',
      test3: '',
      name: '',
      surveyType: '1',
      selectedRadio: 'B',
      selectedRadio2: 'C',
      selectedOption: 'a',
      selectedCheckbox: ['apple'],
      selectedCheckbox2: ['broccoli'],
      checkOptions: [
        { text: 'Orange', value: 'orange' },
        { text: 'Apple', value: 'apple' },
        { text: 'Pineapple', value: 'pineapple' },
        { text: 'Grape', value: 'grape' }
      ],
      checkOptions2: [
        { text: 'Cucumber', value: 'cucumber' },
        { text: 'Tomato', value: 'tomato' },
        { text: 'Onion', value: 'onion' },
        { text: 'Broccoli', value: 'broccoli' }
      ]
    }
  }
}
</script>
